var _g, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChargerKeba(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "425 125 135 135",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#E9E9E9",
    d: "M527.5,133.667c-2.333-2.167-7.982-5.042-11.583-5.042 c14.554,8,5.79,21,8.696,31.582c0.387,1.409,0.036,3.104,0.027,4.621c-0.543,18.336-1.013,36.717-1.711,55.048 c-0.097,2.531-1.051,5.162-2.1,7.517c-1.344,3.016-2.234,8.162-5.702,7.544c-2.887-0.514-0.6-5.571-1.299-8.524 c-6.143-0.702-12.886-5.773-17.647,3.264c-0.729,1.382-5.852,1.368-8.509,0.565c-2.854-0.863-2.675-4.396-2.906-7.117 c-3.549-0.149-7.099-0.297-10.646-0.445c-1.337,20.415-1.336,20.35,18.676,20.453c6.598,0.034,13.271-0.008,19.761,0.967 c3.725,0.56,6.304-5.105,10.166-1.218c0.863,0.868,2.313,1.277,1.287,2.875c-5.093,7.934-10.674,3.562-18.416,8.899 c0.07,1.396-0.656,0.031,1.266,0.234c6.047-3.375,16.974-0.104,18.974-4.891S529.833,135.833,527.5,133.667z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#FCFCFC",
    d: "M474.205,137.479c-0.006-0.274-0.008-0.548-0.007-0.823 c-0.161-2.01-1.221-4.15,0.85-5.835c5.524-0.007,11.05-0.014,16.575-0.021c6.389,0.01,12.779,0.02,19.169,0.03 c1.693-0.074,1.713-1.264,1.667-2.498c1.663,0,2.232,0.398,3.896,0.398c14.554,7.862,5.603,21.061,8.509,31.643 c0.387,1.409,0.036,3.021,0.027,4.539c-3.458,2.964-5.667,7.55-10.808,8.331c-0.016-3.533-0.03-7.066-0.045-10.599 c0.026-0.631,0.053-1.263,0.079-1.894c-0.011-6.337-0.021-12.675-0.032-19.012c0.842-6.933-2.692-0.996-3.845-1.114 C498.246,139.405,486.222,138.483,474.205,137.479z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#E9E9E9",
    d: "M510.792,130.83c-6.39-0.01-12.78-0.02-19.169-0.03 c-1.431-0.267-2.88-0.462-4.289-0.817c-3.227-0.814-7.035,1.831-9.804-1.651c11.088,0,22.177,0,33.265,0 C510.794,129.165,510.793,129.997,510.792,130.83z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#F7F7F7",
    d: "M475.048,130.821c-2.07,1.685-1.011,3.826-0.85,5.835 c-1.209-0.247-2.437-0.425-3.621-0.756c-2.081-0.581-7.907,0.827-6.104-1.923c1.61-2.456,3.015-2.616,4.532-3.976 c0.469-0.42,1.197-0.5,1.537-1.063c1.663,0,2.83-0.606,4.493-0.606C475.039,129.161,475.043,129.991,475.048,130.821z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#D5D5D5",
    d: "M475.048,130.821c-0.005-0.83-0.009-1.66-0.013-2.489 c0.831,0,1.663,0,2.495,0c2.769,3.482,6.577,0.837,9.804,1.651c1.409,0.355,2.858,0.55,4.289,0.817 C486.098,130.807,480.572,130.813,475.048,130.821z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#D5D5D5",
    d: "M510.792,130.83c0.001-0.833,0.002-1.665,0.003-2.498 c0.555,0,1.109,0,1.664,0C512.505,129.566,512.485,130.756,510.792,130.83z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#41474E",
    d: "M514.038,162.643c0.015,3.533,0.029,7.066,0.045,10.599 c0,0.553,0,1.105,0,1.659c0.003,1.387,0.005,2.775,0.008,4.163c-0.134,14.5-0.267,29.001-0.399,43.503 c-9.559,0.186-19.117,0.373-28.675,0.559c-3.549-0.149-7.099-0.297-10.646-0.445c-0.023-20.065-0.046-40.131-0.068-60.197 c9.675-0.083,19.349-0.167,29.023-0.25C506.896,162.369,510.467,162.506,514.038,162.643z M504.102,189.92 c0.157,0.13,0.315,0.261,0.473,0.393c-0.128-0.161-0.256-0.321-0.385-0.481c-0.229-0.088-0.457-0.176-0.686-0.264 C503.703,189.686,503.901,189.803,504.102,189.92z M495.951,187.15c0.787,0.039,1.573,0.078,2.359,0.117 c1.178,0.523,2.353,1.047,3.541,1.543c0.011,0.005,0.183-0.375,0.279-0.575c-1.307-0.499-2.613-0.998-3.92-1.497 c-0.793-0.065-1.586-0.13-2.38-0.196c-1.036-1.125-1.881-0.869-2.592,0.359c-1.036-0.042-2.071-0.085-3.107-0.128 c-1.15,0.48-2.3,0.959-3.45,1.439c-0.114,0.047-0.245,0.073-0.334,0.149c-0.05,0.042-0.029,0.167-0.039,0.254 c0.121-0.137,0.242-0.275,0.363-0.413c1.116-0.338,2.232-0.676,3.349-1.014c1.045-0.058,2.089-0.115,3.134-0.173 C494.087,187.061,495.019,187.105,495.951,187.15z M494.542,179.157c0,0.039,0,0.078,0,0.117c-4.422,0-8.845-0.028-13.267,0.03 c-0.681,0.009-1.355,0.418-2.034,0.642c0.604,0.165,1.209,0.469,1.814,0.472c8.71,0.056,17.42,0.089,26.129,0.063 c0.662-0.002,1.322-0.498,1.982-0.763c-0.728-0.187-1.453-0.526-2.184-0.535C502.837,179.13,498.689,179.157,494.542,179.157z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#D5D5D5",
    d: "M474.349,162.515c0.022,20.066,0.045,40.132,0.068,60.197 c-1.337,20.415-1.336,20.349,18.676,20.452c6.598,0.034,13.271-0.008,19.761,0.967c3.725,0.56,6.304-5.105,10.166-1.218 c0.863,0.868,2.313,1.277,1.287,2.875c-5.093,7.934-10.025,5.837-12.199,6.3c-12.156-1.035-24.312-1.604-36.465,0.026 c-5.801-1.395-11.831-3.496-11.921-10.388c-0.419-32.494-0.336-64.994-0.431-97.492c14.174-3.651,9.055,7.919,10.89,13.921 C474.592,159.5,474.312,161.056,474.349,162.515z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#F7F7F7",
    d: "M514.083,174.901c0-0.553,0-1.106,0-1.659 c5.141-0.781,7.35-5.367,10.808-8.331c-0.543,18.336-1.013,36.676-1.711,55.007c-0.097,2.531-1.051,5.141-2.1,7.496 c-1.344,3.016-2.234,8.151-5.702,7.534c-2.887-0.514-0.6-5.576-1.298-8.529c-0.13-1.284-0.26-2.568-0.389-3.852 c0.133-14.501,0.266-29.002,0.399-43.503C516.746,177.671,516.748,176.283,514.083,174.901z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#D5D5D5",
    d: "M513.691,222.567c0.129,1.284,0.259,2.568,0.389,3.852 c-6.144-0.702-12.887-5.776-17.648,3.261c-0.729,1.382-5.852,1.367-8.509,0.564c-2.854-0.863-2.675-4.396-2.906-7.118 C494.574,222.939,504.133,222.753,513.691,222.567z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#949494",
    d: "M463.617,143.777c0.095,32.498,0.012,64.998,0.431,97.492 c0.09,6.892,7.515,10.013,11.921,10.388c6.09-0.186,37.313-0.021,39.332-0.333c2.287-0.354,4.569,0.703,5.897,0.828 c-1.578,0.828-1.507,0.222-9.125,2.266c-10.555,2.832-28.673,4.899-38.646,2.74c-8.609-3.885-14.709-8.498-14.648-18.053 c0.184-29.201,0.354-58.403,0.913-87.598c0.107-5.639,2.165-18.073,5.837-18.854c0.086,0.911-1.825,3.907-1.739,4.818 C463.991,139.6,463.415,141.647,463.617,143.777z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#F7F7F7",
    d: "M514.038,162.643c-3.571-0.137-7.142-0.274-10.713-0.41 c1.965-11.063-0.26-14.853-11.065-17.714c-5.253-1.391-10.653-2.344-16.045-3.049c-3.226-0.422-1.519-2.595-2.01-3.99 c12.017,1.004,24.041,1.926,36.035,3.145c1.152,0.118,4.687-5.819,3.846,1.112c-1.237,6.339-1.329,12.677,0.031,19.013 C514.091,161.38,514.064,162.012,514.038,162.643z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#D5D5D5",
    d: "M514.117,160.75c-1.36-6.336-1.269-12.674-0.031-19.013 C514.096,148.075,514.106,154.413,514.117,160.75z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#949494",
    d: "M494.542,179.157c4.147,0,8.295-0.027,12.441,0.025 c0.73,0.009,1.456,0.348,2.184,0.535c-0.66,0.266-1.32,0.761-1.982,0.763c-8.709,0.027-17.419-0.006-26.129-0.063 c-0.605-0.003-1.21-0.308-1.814-0.472c0.679-0.224,1.354-0.633,2.034-0.642c4.422-0.059,8.845-0.03,13.267-0.03 C494.542,179.235,494.542,179.196,494.542,179.157z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#FCFCFC",
    d: "M514.083,174.901c2.665,1.382,2.663,2.771,0.008,4.163 C514.088,177.676,514.086,176.288,514.083,174.901z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#949494",
    d: "M498.211,186.738c1.307,0.499,2.613,0.998,3.92,1.497 c-0.097,0.2-0.269,0.58-0.279,0.575c-1.188-0.496-2.363-1.021-3.54-1.543C498.238,187.098,498.204,186.922,498.211,186.738z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#949494",
    d: "M490.021,187.189c-1.117,0.338-2.233,0.676-3.35,1.014 l0.01,0.009c1.15-0.48,2.3-0.959,3.45-1.439C490.168,186.931,490.13,187.069,490.021,187.189z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#949494",
    d: "M493.239,186.901c0.711-1.228,1.556-1.484,2.592-0.359 c0.106,0.189,0.146,0.393,0.12,0.608c-0.933-0.045-1.864-0.089-2.797-0.134L493.239,186.901z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#D5D5D5",
    d: "M493.239,186.901l-0.085,0.115 c-1.045,0.058-2.089,0.115-3.134,0.173c0.109-0.12,0.147-0.258,0.111-0.416C491.168,186.816,492.203,186.859,493.239,186.901z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#D5D5D5",
    d: "M495.951,187.15c0.025-0.215-0.014-0.418-0.12-0.608 c0.794,0.065,1.587,0.13,2.38,0.196c-0.007,0.184,0.027,0.36,0.101,0.529C497.524,187.228,496.738,187.189,495.951,187.15z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#949494",
    d: "M486.672,188.203c-0.121,0.138-0.242,0.275-0.363,0.413 c0.01-0.087-0.011-0.212,0.039-0.254c0.089-0.076,0.22-0.102,0.334-0.149L486.672,188.203z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#949494",
    d: "M504.1,189.921c-0.198-0.118-0.396-0.235-0.596-0.354 c0.229,0.088,0.457,0.176,0.686,0.264L504.1,189.921z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#949494",
    d: "M504.189,189.832c0.129,0.16,0.257,0.32,0.385,0.481 c-0.157-0.131-0.315-0.262-0.474-0.392C504.1,189.921,504.189,189.832,504.189,189.832z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "none",
    stroke: "#000000",
    strokeMiterlimit: 10,
    d: "M524.5,242.65 c-0.844,3.6-5.964,7.85-9.21,8.85h-42.711c-4.079-1.313-7.642-3.938-9.079-8.85V138.101c1.02-5.381,5.5-9.257,9.079-9.601h42.711 c3.429-0.156,8.21,4.989,9.21,9.601V242.65z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChargerKeba);
export default __webpack_public_path__ + "static/media/charger_keba.a62d99426b0787d23de14a7d20bde9df.svg";
export { ForwardRef as ReactComponent };